<template>
  <div class="card-content-table">
      <table>
        <thead>
          <tr class="border-bottom">
            <th v-for="column in columns" :key="column">
              {{ column }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in data" :key="i" class="">
            <td>{{ item.orderDate }}</td>
            <td>{{ `${formatNumber(item.value)} ${item.unit}` }}</td>
            <td>{{ formatRate(item.rate) }}</td>
          </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
import Util from '@/common/utility'

export default {
  props: {
    columns: {
      type: Array
    },
    data: {
      type: Array
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    formatRate (rate) {
      if (rate > 0) {
        return `+${rate}%`
      }

      return `${rate}%`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/home/components/TableSalesGrowth.vue